module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-slot page",
    attrs: {
      "id": "page-slot"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12-sm col-8"
  }, [_c('img', {
    staticClass: "page-splash__logo",
    attrs: {
      "src": require("../../assets/images/logo.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Dank voor het invullen. We hebben jouw persoonlijke profiel naar je gestuurd!")]), _vm._v(" "), _c('p', [_vm._v("Mocht je deze na enige tijd nog niet hebben ontvangen, controleer dan je 'ongewenste e-mail'.\n                        Mocht je profiel ook daar niet te vinden zijn, stuur dan een e-mail naar\n                        "), _c('a', {
    attrs: {
      "href": "mail:info@hybridedocent.com"
    }
  }, [_vm._v("info@hybridedocent.com")]), _vm._v(".\n                    ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c688fb8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-slot.vue
// module id = 136
// module chunks = 0